<template>
  <div id="tramiteEnviado">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Trámite / Enviados
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title>
          <!-- <v-select
            label="Tipo de trámite"
            :items="tipo_tramite"            
            item-value="id"
            item-text="descripcion"
          ></v-select> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="enviados"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.item.idt }}</td>
            <td>{{ props.item.codigo_tabla }}</td>
            <td>{{ props.item.nombre_tabla }}</td>
            <td>{{ props.item.flujo }}</td>
            <td>{{ props.item.tramite_tipo }}</td>
            <td>{{ props.item.proceso_tipo }}</td>
            <td>{{ props.item.obs }}</td>
            <td>{{ props.item.tramite_estado }}</td>
            <td>{{ props.item.fecha_recepcion }}</td>
            <td>{{ props.item.plazo }}</td>
            <td>{{ props.item.fecha_envio }}</td>
            <td>{{ props.item.fecha_vencimiento }}</td>
            <td>{{ props.item.nombre }}</td>
            <td>
              <v-btn
                v-if="props.item.ruta_reporte != ''"
                icon
                dark
                color="primary"
                small
                @click="formularioCctp(props.item.idt)"
              >
                <v-icon small>print</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="mdialog" max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Detalle</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            Detalle del tramite
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="mdialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
      <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from '../services/general';
import axios from 'axios';
export default {
  name: 'tramite-enviado',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nro', align: 'left', value: 'idt', sortable: false },
        { text: 'Código ', value: 'codigo_tabla' },
        { text: 'Nombre ', value: 'nombre_tabla' },
        { text: 'Trámite ', value: 'flujo' },
        { text: 'Tipo Trámite ', value: 'tramite_tipo' },
        { text: 'Tarea ', value: 'proceso_tipo' },
        { text: 'Observación ', value: 'obs' },
        { text: 'Estado ', value: 'tramite_estado' },
        { text: 'Fecha Recepción ', value: 'fecha_recepcion' },
        { text: 'Plazo(días) ', value: 'plazo' },
        { text: 'Fecha Envío ', value: 'fecha_envio' },
        { text: 'Fecha Vencimiento ', value: 'fecha_vencimiento' },
        { text: 'Usuario Remitente ', value: 'nombre' },
        { text: 'Acciones', sortable: false, width: '160px' }
      ],
      loading: false,
      enviados: [],
      tipo_tramite: [],
      mdialog: false,
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.tipo_tramite = [
      {id: 1, descripcion: 'Ratificación'},
      {id: 2, descripcion: 'Ampliación'},
      {id: 3, descripcion: 'Cambio de Razón Social'},
      {id: 4, descripcion: 'Cambio de Domicilio'},
      {id: 5, descripcion: 'Cambio de derecho Propietario'},
      {id: 6, descripcion: 'Cierre del Centro de Capacitación'}
    ];
    this.dparams = Service.getParams();
    if (this.dparams != null) {
      this.getEnviados();
    }
  },
  computed: {},
  methods: {
    getEnviados() {
      this.loading = true;
      this.dparams.tipo = 3;
      axios
        .post(Service.getServe() + 'tramite/lista', this.dparams, Service.getHeader())
        .then(response => {
          this.enviados = response.data.entities;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error('Error al cargar registros', error);
        });
    },

    formularioCctp(tramite_id) {//flujo_tipo_id
      // var ruta = ;
      // if (flujo_tipo_id == Service.getFlujoTipo().flujo_m) {
      // }
      axios.get(Service.getBase() + 'tramite/tarea/1/' + tramite_id, Service.getHeader()).then(response => {
        var datos = (response.data.datos != '') ? JSON.parse(response.data.datos) : {};
        if (datos.tipo_tramite.includes(1)) {
          Service.formularioCctpApertura(datos);
        } else if (datos.tipo_tramite.includes(8)) {
          Service.formularioCctpSubsede(datos);
        } else if (datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6)) {
          //1671390
          Service.formularioCctpModifica(datos);
        }
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },

    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>